import { format } from "date-fns";

import { parseRouteParamDate } from "@/common/helper/commonHelper";
import { ClientSearchParam } from "@/router/ClientRoutes";

import { ClientsFilterType } from "./Clients.types";

export function getClientsFilterParam(key: keyof ClientsFilterType): ClientSearchParam {
  switch (key) {
    case "searchText":
      return ClientSearchParam.Search;
    case "salutation":
      return ClientSearchParam.Salutation;
    case "title":
      return ClientSearchParam.Title;
    case "name":
      return ClientSearchParam.Name;
    case "birthday":
      return ClientSearchParam.Birthday;
    case "insuranceNumber":
      return ClientSearchParam.InsuranceNumber;
    case "caseNumber":
      return ClientSearchParam.CaseNumber;
    case "srvFileNumber":
      return ClientSearchParam.SrvFileNumber;
    case "courtId":
      return ClientSearchParam.CourtId;
    case "street":
      return ClientSearchParam.Street;
    case "zipCode":
      return ClientSearchParam.ZipCode;
    case "city":
      return ClientSearchParam.City;
    case "nationality":
      return ClientSearchParam.Nationality;
    case "mediaInquiry":
      return ClientSearchParam.MediaInquiry;
    case "caseNoteDateFrom":
      return ClientSearchParam.CaseNoteDateFrom;
    case "caseNoteDateTo":
      return ClientSearchParam.CaseNoteDateTo;
    case "caseNoteKeyword":
      return ClientSearchParam.CaseNoteKeyword;
    case "assignedCounselorId":
      return ClientSearchParam.AssignedCounselorId;
    case "status":
      return ClientSearchParam.Status;
  }
}

export function buildClientsFilterSearchParams(filters: ClientsFilterType) {
  const params = new URLSearchParams();

  (Object.entries(filters) as Array<[keyof ClientsFilterType, ClientsFilterType[keyof ClientsFilterType]]>).forEach(
    ([key, value]) => {
      const stringValue = stringifyClientsFilterValue(value);
      if (stringValue != null) {
        params.set(getClientsFilterParam(key), stringValue);
      }
    }
  );

  return params;
}

export function stringifyClientsFilterValue(value: ClientsFilterType[keyof ClientsFilterType]): string | null {
  if (value == null) {
    return null;
  }

  if (value instanceof Date) {
    return format(value, "yyyy-MM-dd");
  }

  if (typeof value === "string" && value.length === 0) {
    return null;
  }

  return value;
}

export function mapClientsFilterFromSearchParams(searchParams: URLSearchParams): ClientsFilterType {
  return {
    searchText: searchParams.get(ClientSearchParam.Search) ?? null,
    salutation: searchParams.get(ClientSearchParam.Salutation) ?? null,
    title: searchParams.get(ClientSearchParam.Title) ?? null,
    name: searchParams.get(ClientSearchParam.Name) ?? null,
    birthday: parseRouteParamDate(searchParams.get(ClientSearchParam.Birthday)),
    insuranceNumber: searchParams.get(ClientSearchParam.InsuranceNumber) ?? null,
    caseNumber: searchParams.get(ClientSearchParam.CaseNumber) ?? null,
    srvFileNumber: searchParams.get(ClientSearchParam.SrvFileNumber) ?? null,
    courtId: searchParams.get(ClientSearchParam.CourtId) ?? null,
    street: searchParams.get(ClientSearchParam.Street) ?? null,
    zipCode: searchParams.get(ClientSearchParam.ZipCode) ?? null,
    city: searchParams.get(ClientSearchParam.City) ?? null,
    nationality: searchParams.get(ClientSearchParam.Nationality) ?? null,
    mediaInquiry: searchParams.get(ClientSearchParam.MediaInquiry) ?? null,
    caseNoteDateFrom: parseRouteParamDate(searchParams.get(ClientSearchParam.CaseNoteDateFrom)),
    caseNoteDateTo: parseRouteParamDate(searchParams.get(ClientSearchParam.CaseNoteDateTo)),
    caseNoteKeyword: searchParams.get(ClientSearchParam.CaseNoteKeyword) ?? null,
    assignedCounselorId: searchParams.get(ClientSearchParam.AssignedCounselorId) ?? null,
    status: searchParams.get(ClientSearchParam.Status) ?? null,
  };
}

export const ClientsTableWidth = {
  caseNumber: 120,
  status: 100,
  counselor: 200,
  birthday: 100,
  insuranceNumber: 150,
  phone: 150,
  personalBankruptcyFileNumber: 300,
};
